import {Save} from "@mui/icons-material";
import {Fab} from "@mui/material";
import {MouseEventHandler, ReactNode} from "react";
import './FloatIcon.scss'

interface FloadIconProps {
    onClick?: any;
    children: ReactNode;
}

export default ({children, onClick}: FloadIconProps) => <div className='floatIconBTN'>
    <Fab  variant="circular" size={"small"} onClick={onClick}>
        {children}
    </Fab>
</div>